export const APP_CLIENT_ID = 'AndroidAppClient';
